/**
 * Sets body.sgOverlayOpen while a popup backdrop is on screen, so the floating
 * copilot drawer can dim itself. There is no shared popup component to hook, so
 * the bg-mask mixin starts a no-op `sgMaskIn` animation on every tinted
 * backdrop and this listens for it once at the document.
 */

const OPEN_CLASS = "sgOverlayOpen";
const ANIMATION = "sgMaskIn";

const onScreen = el => el.isConnected && el.getClientRects().length > 0;

export default function watchOverlays() {
  const live = new Set();
  let observer = null;

  const sync = () => {
    live.forEach(el => {
      if (!onScreen(el)) live.delete(el);
    });
    const open = live.size > 0;
    document.body.classList.toggle(OPEN_CLASS, open);

    if (open && !observer) {
      observer = new MutationObserver(sync);
      observer.observe(document.body, { childList: true, subtree: true });
    } else if (!open && observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const onAnimationStart = event => {
    if (event.animationName !== ANIMATION) return;
    live.add(event.target);
    sync();
  };

  document.addEventListener("animationstart", onAnimationStart, true);

  return () => {
    document.removeEventListener("animationstart", onAnimationStart, true);
    if (observer) observer.disconnect();
    live.clear();
    document.body.classList.remove(OPEN_CLASS);
  };
}
